export default __webpack_public_path__ + "static/media/Leggings of Ferine Anger.d5397d82.jpg";